import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgUtilsService } from '../../ajs-upgraded-providers';
import { FlagService } from '../../core/flag.service';
import { FileService } from '../../rl-common/file/core/file.service';
import { RlFile } from '../../rl-common/file/shared/rl-file';
import { FormConfig } from '../../rl-common/forms/shared/form-config-abstract';
import { CitationAvailabilityService } from '../../rl-common/link-access/core/citation-availability.service';
import { MarkAsBrokenParams } from './mark-as-broken-params';

@Component({
  selector: 'rl-mark-as-broken',
  templateUrl: './mark-as-broken.component.html',
  styleUrls: ['./mark-as-broken.component.scss']
})
export class MarkAsBrokenComponent implements OnInit {

  @Input() isFile : boolean;
  @Input() citationId : any;
  @Input() params : MarkAsBrokenParams;
 
  @Output() onConfirm : EventEmitter<void> = new EventEmitter<void>();

  displayCopyButton : boolean = true; 
  feedback : string;
  warningLabel : string;
  isFeedbackMandatory : boolean;
  displayFeedbackWarning : boolean;
  displayUploadFile : boolean;
   
  constructor(private translate : TranslateService, private citationAvailService : CitationAvailabilityService, private ngUtilsService : NgUtilsService,
    private flagService : FlagService, private fileService : FileService, private changeDetect: ChangeDetectorRef) { }

  ngOnInit(): void {
    let label = this.isFile ? 'citation.action.report_broken_file.user_info' : 'citation.action.report_broken_link.confirm.user_info';
    this.warningLabel = this.translate.instant(label);
    this.isFeedbackMandatory = this.flagService.features().mark_as_broken_comment_mandatory == 'true';
    this.displayUploadFile = this.flagService.showMarkAsBrokenUploadFile();
  }
  
  cancel = () : void => {};

  confirm = () : void => {}

  confirmClick = () : void => {
    this.params.feedback = this.feedback;
    this.citationAvailService.markAsBroken(this.citationId, this.params).subscribe(() => {
      this.ngUtilsService.toast(this.translate.instant('citation.action.report_broken_link.info'));
      if (this.params.amazonFileKey && this.params.amazonFileName) {
        this.fileService.storeFile(this.params.amazonFileKey).subscribe();
      }
      this.confirm();
    });
  }

  validateForm = () : boolean => {
    this.displayFeedbackWarning = this.isFeedbackMandatory && (this.feedback == undefined || this.feedback == '');
    this.changeDetect.detectChanges();
    return !this.displayFeedbackWarning;
  }

  onfileUploaded = (e : RlFile) : void => {
    this.params.amazonFileKey = e.amazonFileKey;
    this.params.amazonFileName = e.amazonDisplayFileName;
  }
}
